import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { NAV_ROUTES } from '../../utils/constants';

const Navbar = () => {
  const { t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);  // ← add this

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);  // ← simplified
  const toggleMenu = () => setMenuOpen(prev => !prev);  // ← add this

  return (
    <nav className={`cf-navbar navbar navbar-expand-xl${scrolled ? ' scrolled' : ''}`}>
      <div className="container">
        {/* Brand */}
        <NavLink to="/" className="navbar-brand p-0 me-3" onClick={closeMenu}>
          <span className="cf-brand-name">चैत्राली फाउंडेशन</span>
          <span className="cf-brand-sub">Chaitralee Foundation</span>
        </NavLink>

        {/* Toggler — now React-controlled */}
        <button
          className="navbar-toggler-custom d-xl-none"
          type="button"
          onClick={toggleMenu}          // ← React handler, no data-bs-* needed
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
        >
          <i className={`bi ${menuOpen ? 'bi-x-lg' : 'bi-list'}`}></i>  {/* ← bonus: X icon when open */}
        </button>

        {/* Nav links — controlled by menuOpen state */}
        <div className={`collapse navbar-collapse${menuOpen ? ' show' : ''}`} id="cfNavCollapse">
          <ul className="navbar-nav me-auto mb-2 mb-xl-0">
            {NAV_ROUTES.map(({ key, path, end }) => (
              <li className="nav-item" key={key}>
                <NavLink
                  to={path}
                  end={end}
                  className={({ isActive }) =>
                    `cf-nav-link nav-link${isActive ? ' active-link' : ''}`
                  }
                  onClick={closeMenu}
                >
                  {t(key)}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;